import * as mutationTypes from "../store/mutation-types";
import {store} from "../store";
import VouchersProvider from "../providers/VouchersProvider";
import appConfig from "../appconfig";

export const voucherValidationHelper = async (self, voucherCodeOrId, skipReservation = false, label = "") => {
	const {customerDetails, globalSelectedShop, isSunsetPointsMember} = store.getters;
	const input = {
		success: true,
		message: self.$t("utilityComponents.voucherInput.voucherActive")
	};
	try {
		if (voucherCodeOrId === ((customerDetails || {}).meta || {}).friendInviteCode) {
			if (isChannelSupported()) {
				input.message = self.$t("utilityComponents.voucherInput.friendInviteSunsetPointBadCode");
			} else {
				input.message = self.$t("utilityComponents.voucherInput.friendInviteChannelBad");
			}
			store.commit(mutationTypes.ADD_FRIEND_INVITE_CODE_TO_ORDER, undefined);
			input.success = false;
		} else {
			const voucherData = await VouchersProvider.redeemVoucher(
				voucherCodeOrId,
				globalSelectedShop.id,
				skipReservation,
				label
			);
			// we need this !store.getters.voucherVirtualOrderId because voucherVirtualOrderId is set for the mystery box
			// just before this step
			if(voucherData && voucherData.voucherVirtualOrderId && !store.getters.voucherVirtualOrderId) {
				store.commit(mutationTypes.SET_VOUCHER_VIRTUAL_ORDER_ID, voucherData.voucherVirtualOrderId);
			}
			if (voucherData && voucherData.pleaseLoginToUseFriendInviteCode) {
				if (isChannelSupported()) {
					input.message = self.$t("utilityComponents.voucherInput.friendInviteGuest");
				} else {
					input.message = self.$t("utilityComponents.voucherInput.friendInviteChannelBad");
				}
				store.commit(mutationTypes.ADD_FRIEND_INVITE_CODE_TO_ORDER, undefined);
				input.success = false;
			} else if (voucherData && voucherData.itIsNotUsersFirstOrder) {
				if (isChannelSupported()) {
					input.message = self.$t("utilityComponents.voucherInput.friendInviteNotFirstOrder");
				} else {
					input.message = self.$t("utilityComponents.voucherInput.friendInviteChannelBad");
				}
				store.commit(mutationTypes.ADD_FRIEND_INVITE_CODE_TO_ORDER, undefined);
				input.success = false;
			}
			else if (voucherData && voucherData.isFriendInviteCodeValid) {
				if (!isChannelSupported()) {
					input.success = false;
					input.message = self.$t("utilityComponents.voucherInput.friendInviteChannelBad");
					store.commit(mutationTypes.ADD_FRIEND_INVITE_CODE_TO_ORDER, undefined);
				} else if (isSunsetPointsMember) {
					input.message = self.$t("utilityComponents.voucherInput.friendInviteVoucherActive").replace(/{{\s?pointsToGrant\s?}}/gi, customerDetails.sunsetPoints.friendInvite.pointsToGrant);
					store.commit(mutationTypes.ADD_FRIEND_INVITE_CODE_TO_ORDER, voucherCodeOrId);
				} else {
					input.success = false;
					input.message = self.$t("utilityComponents.voucherInput.friendInviteGuest");
					store.commit(mutationTypes.ADD_FRIEND_INVITE_CODE_TO_ORDER, undefined);
				}
			} else if(voucherData && voucherData.voucherId) {
				// ensure that only last valid voucher is applied and stored
				await store.dispatch(mutationTypes.CLEAR_VOUCHERS_FROM_ORDER);
				await store.dispatch(mutationTypes.ADD_VOUCHER_TO_ORDER, voucherData);
			} else {
				store.commit(mutationTypes.ADD_FRIEND_INVITE_CODE_TO_ORDER, undefined);
				input.success = false;
				input.message = self.$t("utilityComponents.voucherInput.missingModel");
			}
		}
	} catch(e) {
		store.commit(mutationTypes.ADD_FRIEND_INVITE_CODE_TO_ORDER, undefined);
		input.message = mapError(self, e);
		input.success = false;
	}
	return input;
};

const mapError = (self, error) => {
	switch(error.response.data.message){
	case "voucher-redemption-rules-model-missing":
		return self.$t("utilityComponents.voucherInput.missingRedemptionRule");
	case "expired-voucher":
		return self.$t("utilityComponents.voucherInput.expired");
	case "exceeded-max-usages":
		return self.$t("utilityComponents.voucherInput.maxUsages");
	case "missing-price-rule":
		return self.$t("utilityComponents.voucherInput.missingPriceRule");
	case "voucher-model-missing":
		return self.$t("utilityComponents.voucherInput.missingModel");
	case "invalid-shop":
		return self.$t("utilityComponents.voucherInput.invalidShop");
	default:
		return self.$t("utilityComponents.voucherInput.error");
	}
};

const isChannelSupported = () => {
	const {envPrefix} = store.getters;
	if (envPrefix === "p") {
		return appConfig.channelAlias() === "mobileApp";
	} else {
		return ["mobileApp", "mobileBrowser"].includes(appConfig.channelAlias());
	}
};
